import * as React from 'react';

import { cn } from '../lib/utils';

export type InputProps = React.ComponentPropsWithRef<'input'>;

const DATUMSARTEN = new Set([
  'date',
  'time',
  'datetime-local',
  'month',
  'week',
]);

const Input: React.FC<InputProps> = ({
  className,
  type = 'text',
  ...props
}) => {
  return (
    <input
      type={type}
      className={cn(
        'text-foreground border-input file:text-foreground hover:border-border-accent placeholder:text-muted-foreground focus-visible:border-primary focus-visible:ring-ring bg-input-background disabled:bg-muted disabled:text-disabled-foreground text-lead rounded-control flex h-11 w-full border px-3 py-1 transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-1 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:border-transparent md:text-base',
        /*
          iOS-Safari gibt Datums- und Zeitfeldern eine Eigenbreite und
          ignoriert dafür `w-full`: „Erster Termin" ragte am iPhone rechts über
          den Karteninnenrand (Auftraggeber 06.10.2026). `appearance-none` und
          `min-w-0` nehmen die Eigenbreite weg, der Wert steht links wie in
          jedem anderen Feld. EIN Ort für alle Datumsfelder.
        */
        DATUMSARTEN.has(type) &&
          'min-w-0 appearance-none [&::-webkit-date-and-time-value]:text-left',
        className,
      )}
      {...props}
    />
  );
};

Input.displayName = 'Input';

export { Input };
